import { EmptyTableState } from '@/modules/common/components/EmptyTableState';
import { getDefaultMRTOptions } from '@/modules/common/lib/react-material-table';
import { IInvitation } from '@/types/invitation';
import {
  MRT_TableOptions,
  MaterialReactTable,
  useMaterialReactTable,
} from 'material-react-table';
import { getListInvitationsTableColumns } from './ListInvitationsTable.constants';
import { InvitationInTheTable } from './ListInvitationsTable.types';

type ListInvitationsTableProps = {
  invitations: IInvitation[];
  isLoading?: boolean;
  tableOptions?: Omit<
    MRT_TableOptions<InvitationInTheTable>,
    'columns' | 'data'
  >;
};

const defaultMRTOptions = getDefaultMRTOptions<InvitationInTheTable>();

export function ListInvitationsTable({
  invitations,
  isLoading = false,
  tableOptions = {},
}: ListInvitationsTableProps) {
  const columns = getListInvitationsTableColumns();

  const table = useMaterialReactTable<InvitationInTheTable>({
    ...defaultMRTOptions,
    ...tableOptions,
    columns,
    data: invitations,
    state: {
      density: 'comfortable',
      ...tableOptions.state,
      isLoading,
    },
    renderEmptyRowsFallback: () => {
      return (
        <EmptyTableState
          hasFilters={false}
          emptyStateImage="/images/no-invitations.png"
          emptyStateTitle="No Invitations found"
          emptyStateMessage="Invite members—once sent, their invitations will appear here."
        />
      );
    },
  });

  return <MaterialReactTable table={table} />;
}
